import { render } from "./BDropdown.vue?vue&type=template&id=1044be78&scoped=true&ts=true"
import script from "./BDropdown.vue?vue&type=script&lang=ts"
export * from "./BDropdown.vue?vue&type=script&lang=ts"

import "./BDropdown.vue?vue&type=style&index=0&id=1044be78&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1044be78"]])

export default __exports__